import styled from "styled-components";

export const StyledProfessions = styled.div`
    display: flex;
    flex-direction: column;
    height: 100vh;
`;

export const StyledProfessionsContent = styled.div`
    padding: 40px;
    height: 100%;
`;